export function formatData(list, field = "id"){
    let newList = {}
    if (list) {
        list.map((item, i) => {
            newList[item[field]] = item
        })
    }
    return newList
}
export function formatDataClientStats(list){
    let newList = {}
    if (list) {
        list.forEach( item => {
            if (!newList[item.client_city]){
                newList[item.client_city] = {}
            }
            if (!newList[item.client_city][item.year]){
                newList[item.client_city][item.year] = []
            }
            newList[item.client_city][item.year].push(item)
        })
    }
    return newList
}
export function formatDataStats(list, field = "product_id"){
    let newList = {}
    if (list) {
        list.forEach( item => {
            if (!newList[item.year]){
                newList[item.year] = {}
            }
            if (!newList[item.year][field]){
                newList[item.year][field] = []
            }
            newList[item.year][field].push(item)
        })
    }
    return newList
}
export function formatDataSchemas(list, type, field= "id"){
    let newList = {}
    if (list) {
        list.map((item, i) => {
            item.type = type
            newList[item[field]] = item
            
        })
    }
    return newList
}


export function formatDataProds(list){
    let newList = {}
    if (list) {
        list.map((item, i)=>{
            item.src = [] // save photos uri
            newList[item.id] = item
        })

    }
    return newList
}

export function sortByDate(list, field = 'date') {

    return [...list].sort((a, b) => {
        return new Date(a[field]) - new Date(b[field])
    });

}  
export function sortByDateReverse(list, field = 'date') {
    return [...list].sort((a, b) => {
        return new Date(b[field]) - new Date(a[field])
    });

}  
export function checkErrorData(res, type, dispatch) {
	let noError = false
	
	if( !res ){
		dispatch({
			type,
			payload: "pas de réponse"
		})
	} else if (res.error){

		// if (res.error.statusCode === 403){
		// 	dispatch(logout())
		// } else {
        dispatch({
            type,
            payload: res.error.message
        })
		// }
		
	} else {
		noError = true
	}
	return noError
	
}